<template>
  <Modal :visible="visible" @close="$emit('cancel')">
    <template #header>
      <p class="modalTitle">{{ title }}</p>
    </template>
    <template #body>
      <p>{{ message }}</p>
      <slot></slot>
    </template>
    <template #footer>
      <div class="btnWrap">
        <button @click="$emit('cancel')" class="submit-button cancelBtn">No</button>
        <button @click="$emit('confirm')" class="submit-button">Yes</button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import Modal from "@/components/Modal.vue";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  visible: { type: Boolean, required: true },
  title: { type: String, default: "Confirmation" },
});

const emit = defineEmits(["confirm", "cancel"]);
</script>

<style>
    .modal-header, .modal-footer{
        padding: 0!important;
        border-bottom: none !important;
    }
    .modal-container{
        padding: 2rem;
    }
</style>
<style scoped>
    .error {
        color: red;
        margin-top: 8px;
    }
    .single-reserve,
    .bulk-reserve {
        margin-top: 12px;
    }
    .btnWrap {
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .modalTitle{
        font-size: 20px;
        color: var(--blue);
        font-weight: 600;
        text-align: center;
        margin:0;
        & span{
            font-size: 0.9em;
        }
    }
    .guestNameWrap>input {
        margin-top: 1rem;
        width: calc(100% - 2rem);
        padding: 1rem;
    }
    .submit-button {
        background: var(--grad90);
        width: 100%;
        max-width: 300px;
        padding: 1rem;
        border: none;
        color: white;
        border-radius: 10px;
        margin: 0;
        display: block;

        &.cancelBtn{
            background: none;
            border: 1px solid var(--blue);
            color: var(--blue);
            max-width: 150px;
            margin-right: 1rem;
        }

        .submit-button:disabled {
            background: #cccccc;
            cursor: inherit;
        }
    }

    /* トグルスイッチのスタイル */
    .rm-toggle-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1rem;
        padding-top: 1rem;
        width: 100%;
        border-top: 1px dashed var(--midLightBlue);
        & span {
            color: var(--blue);
            font-size: 14px;
            font-weight: 600;
        }
    }
    .rm-toggle-label {
        position: relative;
        display: block;
        width: 60px;
        height: 29px;
        background: #ccc;
        border-radius: 23px;
        cursor: pointer;
        transition: background 0.2s;

        &:after {
            content: "OFF";
            position: absolute;
            top: 3px;
            left: 3px;
            padding: 3px 6px;
            background: white;
            border-radius: 100px;
            transition: transform 0.2s;
            font-size: 14px;
            color: gray;
            font-weight: 600;
        }
    }
    .rm-toggle-input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
        z-index: 1;

        &:checked + .rm-toggle-label {
            background: var(--blue);
        }
        &:checked + .rm-toggle-label:after {
            content: "ON";
            color: var(--blue);
            transform: translateX(20px);
        }
    }
</style>